// ─── PhotoLocationMap ───────────────────────────────────────────────────────
// The gallery info panel's "Show Map" target.
//
// Symfony parity (web/js/project/gallery/gallery.js → showMap()): clicking
// "Show Map" reveals a small map centred on the media's site/location at
// zoom 12, or the text "No location found" when the media has no coordinates.
// Symfony renders a Google *static* map; this stack has no Google key, so it
// reuses the project map's free Esri World Imagery tiles — same hybrid look,
// no key required.
// ────────────────────────────────────────────────────────────────────────────

import { MapContainer, TileLayer, CircleMarker, Popup } from 'react-leaflet'
import { getTileLayer } from './map/mapConfig'

// Symfony's showMap() hardcodes this zoom.
const MEDIA_MAP_ZOOM = 12

export default function PhotoLocationMap({ latitude, longitude, title }) {
    const lat = Number(latitude)
    const lng = Number(longitude)
    const hasCoords = Number.isFinite(lat) && Number.isFinite(lng)

    if (!hasCoords) {
        return (
            <div className="mt-2 rounded border border-gray-200 bg-gray-50 px-3 py-4 text-center text-sm text-gray-500">
                No location found
            </div>
        )
    }

    const layer = getTileLayer('imagery')

    return (
        <div className="mt-2 h-48 overflow-hidden rounded border border-gray-200">
            <MapContainer
                center={[lat, lng]}
                zoom={MEDIA_MAP_ZOOM}
                scrollWheelZoom={false}
                style={{ height: '100%', width: '100%' }}
            >
                <TileLayer url={layer.url} attribution={layer.attribution} maxZoom={layer.maxZoom} />
                <CircleMarker
                    center={[lat, lng]}
                    radius={7}
                    pathOptions={{ color: '#fff', weight: 2, fillColor: '#EF4444', fillOpacity: 1 }}
                >
                    <Popup>
                        <span className="text-xs">
                            {title || 'Media location'}
                            <br />
                            {lat.toFixed(5)}, {lng.toFixed(5)}
                        </span>
                    </Popup>
                </CircleMarker>
            </MapContainer>
        </div>
    )
}
